
<template>
  <div class="commentpage" id='danmubox'> 
    <!-- <mt-actionsheet
      :actions="actions"
      v-model="msheet">
    </mt-actionsheet> -->
    <div class="actionsheet hidden"id='actionsheet' style="z-index: 2019;" v-show="msheet">
      <ul style="margin-bottom: 5px;">
        <li v-clipboard:copy="comment"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError">复制</li>
        <li v-if="keyusercode==userinfo.usercode" @click="deletecomment">删除</li>
      </ul>
      <a @click="hiddensheet">取消</a>
    </div>
    <div class="v-modal" style="z-index: 2004;" v-show="msheet" @click="hiddensheet"></div>
    <div class="popuptitle">共{{commentlist.length}}评论</div>
    <div v-if='showspinner' style="line-height:70vh;text-align:center;"><mt-spinner :type="2" color='#4285f4'></mt-spinner></div>
    <div class="message" v-else>
      <div class="nocomment" style="line-height:70vh;" v-if="commentlist.length<1">暂无评论，来抢沙发</div>
      <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" v-else>
        <li class="comment" v-for="(item,index) in commentlist">
          <div :style="'background-image:url('+item.headerimg+')'" class="userimg"></div>
          <div class="commentbox">
            <div class="commentinfo">
              <div class="name">{{item.username}}</div>
              <div>{{item.commenttime}}</div>
              <h2 class="commenttext" @click="showactionsheet(item.id,item.comment,item.usercode,index)">{{item.comment}}</h2>
            </div>
            <!-- <div :class="item.likestutas==1?'likecount likecolor':'likecount'" @click="likethis('comment',index)">
              <i class="iconfont iconaixin1"></i><div>{{item.likecount}}</div>
            </div> -->
          </div>
          <div class="commentbox relpy" v-if="item.reply"><!--作者回复-->
            <div class="commentinfo">
              <div class="name"><span>作者</span></div>
              <h2 class="commenttext" @click="showactionsheet('',item.reply,'','')">{{item.reply}}</h2>
            </div>
            <!-- <div :class="item.replylikestutas==1?'likecount likecolor':'likecount'" @click="likethis('reply',index)">
              <i class="iconfont iconaixin1"></i><div>{{item.replylikecount}}</div>
            </div> -->
          </div>
        </li>
        <div class="nocomment" style="line-height:25px;">{{loadingtxt}}</div>
      </ul>
    </div>
    <div class="footer">
      <input placeholder="留下你的精彩评论吧" id='danmuinput' type="send" maxlength="100" v-model="userinput" @keyup.enter="senddanmu">
      <span :style="userinput?'background-color: #129611;cursor: pointer;':''" @click="senddanmu">发送</span>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import { getcommentlist } from "@/api/api";
import { sendcomment } from "@/api/api";
import { delcomment } from "@/api/api";
import { Actionsheet } from 'mint-ui';
import { Indicator } from 'mint-ui';
import {mapGetters} from 'vuex';
import { MessageBox } from 'mint-ui';
import { mapActions } from "vuex";
import lrz from 'lrz';
export default {
  data(){
    return{
      userinput:'',
      nextsend:true,
      showMessageBox:true,
      interactid:'',
      danmuid:1,
      showspinner:true,
      danmulist:[],
      commenttype:'',
      keyid:'',
      commentlist:[],
      loadingtxt:'加载更多',
      page:1,
      pagesize:15,
      commenstatus:1,
      actions:[
        {name:'复制',method:this.test},
        {name:'删除',method:this.test},
      ],
      msheet:false,
      keyusercode:'',
      keyindex:'',
      comment:'',
      commentid:'',
    }
  },
  computed:{
    ...mapGetters({
      userinfo:'userInfo',
    }),
  },
  mounted(){
    //this.setwxshare(window.location.href)
    //this.getmsglist()
    
  },
  methods:{
    ...mapActions({
      userOut: "setSignOut"
    }),
    showactionsheet(commentid,comment,usercode,index){
      this.commentid=commentid
      this.comment=comment
      this.keyusercode=usercode
      this.keyindex=index
      this.msheet=true
      setTimeout(() => {  document.getElementById("actionsheet").classList.remove("hidden") }, 150);
    },
    hiddensheet(){
      document.getElementById("actionsheet").classList.add("hidden");
      setTimeout(() => {  this.msheet = false }, 150);
      this.keyusercode=''
      this.comment=''
      this.commentid=''
      this.keyindex=''
    },
    deletecomment(){
      document.getElementById("actionsheet").classList.add("hidden");
      setTimeout(() => {  this.msheet = false }, 150);
      MessageBox({
        title: '提示',
        message: '确定删除评论？',
        showCancelButton: true,
        confirmButtonText:'删除',
        closeOnClickModal:false
      }).then(action => {
          if(action == 'confirm'){
            this.delcomment()
          }  
      });
    },
    onCopy(){
      this.MessageBox('复制成功')
      this.hiddensheet()
    },
    onError(){
      this.MessageBox('复制失败')
      this.hiddensheet()
    },
    delcomment(){
      if(!this.commentid){this.MessageBox('未知错误');return}
      delcomment({ commentid:this.commentid,usercode:this.userinfo.usercode }).then(res => {
        if(res.code==200){
          this.commentlist.splice(this.keyindex,1);
          this.hiddensheet()
        }
        else{
          this.MessageBox(res.msg)
        }
      }); 
    },
    likethis(e,index){
      var type=''
      if(this.goodbutton){return}
      this.goodbutton=true
      if(e=='comment'){
        if(this.commentlist[index].likestutas=='1'){type='0'}
        else{type='1'}
        this.commentlist[index].likestutas=type
      }
      if(e=='reply'){
        if(this.commentlist[index].replylikestutas=='1'){type='0'}
        else{type='1'}
        this.commentlist[index].replylikestutas=type
      }
      if(type=='1'){
        Toast('点赞成功')
        if(e=='comment'){this.commentlist[index].likecount++}
        else{this.commentlist[index].replylikecount++}
      }
      else{
        Toast('取消点赞成功')
        if(e=='comment'){this.commentlist[index].likecount--}
        else{this.commentlist[index].replylikecount--}
      }
      this.goodbutton=false
    },
    firstclick(){
      if(this.secondclick){console.log('第N次点击');return}
      this.getmsglist();
      this.secondclick=true;
      console.log('第1次点击')
    },
    getmsglist(){
      
      this.loadmore=false;
      getcommentlist({ keyid:this.keyid,type:this.commenttype,status:this.commenstatus,page:this.page,pagesize:this.pagesize,usercode:this.userinfo.usercode }).then(res => {
        if(res.code==200){
          this.showspinner=false
          if(res.data.length>0)
          {
            this.commentlist=this.commentlist.concat(res.data);
            this.loadmore=true;
            this.loadingtxt="加载更多"
          }
          else{
            this.loadingtxt="暂时没有更多了"
          }
        }
        else{
          this.MessageBox(res.msg)
        }
      });
    },
    loadMore() {
      console.log('0.0')
      if(this.loadmore)
      {
        this.loadingtxt = '加载中...';
        this.page++;
        this.getmsglist();
      }
    },
    checkplogin(){
      if(this.userinfo.usercode){
        return true
      }
      else{
        MessageBox({
          title: '提示',
          message: '未登录',
          showCancelButton: true,
          confirmButtonText:'去登录',
          closeOnClickModal:false
        }).then(action => {
            if(action == 'confirm'){
              this.toLogin();
            }
        });
      }
    },
    getnowtime(){
      var adddata={};
      var curTime = new Date();
      var hour=curTime.getHours()
      var minute=curTime.getMinutes()
      var second=curTime.getSeconds()
      if(hour<10){hour='0'+hour}
        if(minute<10){minute='0'+minute}
          if(second<10){second='0'+second}
      return hour+':'+minute+':'+second;
    },
    senddanmu(){
      document.getElementById('danmuinput').focus()
      if(!this.userinput){return}
      if(!this.nextsend){return}
      this.nextsend=false
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      sendcomment({ keyid:this.keyid,type:this.commenttype,comment:this.userinput,usercode:this.userinfo.usercode }).then(res => {
        if(res.code==200){
          this.userinput=''
          this.MessageBox('评论成功，等待作者审核。')
          Indicator.close()
        }
        else{
          this.MessageBox(res.msg)
        }
        this.nextsend=true
      }); 
      
    },
    scrolltotop(){
      var a=document.getElementById('danmubox')
      let i=1
      if (a.scrollTop>0) {
        numDHT();
      }
      function numDHT(){
        if (i < 11) {
          setTimeout(function() {
            a.scrollTop=a.scrollTop-a.scrollTop/10*i
            i++
            numDHT();
          }, 20)
        }
      }
    },
    toLogin(){
      this.userOut()
      this.$router.push('/account/login');
    },
    tousercenter(usercode){
      Toast(usercode)
    },
    MessageBox(msg){
      Indicator.close()
      MessageBox({
        title: '提示',
        message: msg,
        closeOnClickModal:false,
      }).then(action => {

      });
    },
  },
  created() {

  }
};




</script>

<style lang="stylus" scoped>
.hidden
  transform: translate3d(0, 100%, 0);
.err
  height:20px
  width:20px
  color:#fff
  border-radius:100%
  line-height:20px;
  background:red
  font-size:18px;
  text-align:center;
.suc
  height:20px
  width:20px
  color:green
  i
    font-size:20px
*,:after,:before
  -webkit-box-sizing:border-box
  -moz-box-sizing:border-box
  box-sizing:border-box
  margin:0
  padding:0
.divHeight 
  width: 100%;
  height: 10px;
  background: #f5f5f5;
  position: relative;
  overflow: hidden;
ul,li
  list-style:none
#danmubox
  transition: .2s ease-out;
.commentpage
  width 100%
  height 90vh
  background-color: #fff;
  overflow: scroll;
  padding:35px 0 20px 0
  .actionsheet
    position: fixed;
    background: #e0e0e0;
    width: 100%;
    text-align: center;
    bottom: 0;
    left:0;
    backface-visibility: hidden;
    transition: transform .15s ease-out, -webkit-transform .15s ease-out;
    li,a
      display: block;
      width: 100%;
      height: 45px;
      line-height: 45px;
      font-size: 18px;
      color: #333;
      background-color: #fff;
    li
      border-bottom: solid 1px #e0e0e0;
  .nocomment
    color:#808183
    text-align:center
    font-size:14px
  .popuptitle
    font-size: 14px
    font-weight: bold
    line-height: 35px
    text-align:center
    position:fixed
    top:0
    left:0
    width:100%
    height:35px
    background-color:#fff
    z-index: 2
  .message
    background-color: #fff;
    ul
      padding-bottom:60px;
      .comment
        padding: 10px 20px 10px 65px;
        height: auto;
        //border-bottom: solid 2px #f5f5f5;
        position: relative;
        color: #000000;
        font-size: 16px;
        .userimg
          position: absolute;
          left: 20px;
          width: 37px;
          height: 37px;
          border-radius: 100%;
          background-size: cover;
        .relpy
          margin-top:10px
        .commentbox
          color: #8f8f8f;
          font-size: 13px;
          display: flex;
          justify-content: space-between;
          .commentinfo
            overflow: hidden;
            div
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            .name
              font-weight:bold
              span
                border-left:2px #18A017 solid
                padding-left: 4px;
            .commenttext
              word-break: break-all;
              color: #000;
              font-size: 16px;
              margin-top: 5px;
              font-weight: normal;
          .likecount
            padding-top:5px
            text-align:center
            color:#DBDBDE
            div
              line-height:16px
            i
              font-size:20px
          .likecolor
            color:#FF2952
  .footer
    position: fixed;
    display:flex
    bottom: 0;
    height: 58px;
    background-color: #fff;
    width: 100%;
    border-top: 1px solid #ddd;
    align-items: center;
    padding:0 10px
    input,textarea
      flex:1
      height: 37px;
      border-radius: 5.8px;
      border: 0.6px solid #ddd;
      padding: 0 13px;
      font-size:16px
      width:0
    span
      font-size: 16px;
      color: #fff;
      padding:6px 10px
      text-align: center;
      margin-left:10px
      background-color: #ddd;
      border-radius: 5px;
    .picfile
      padding:0 10px
      height: 100%;
      align-items: center;
      display: flex;
      i
        width:30px
        height:30px
        font-size:28px
        line-height:30px
        text-align: center;
a {
    text-decoration: none;
    color: #08acee;
}

button {
    outline: 0;
}

img {
    border: 0;
}

button,input,optgroup,select,textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
}

li {
    list-style: none;
}

a {
    color: #666;
}

.clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
}
div, dl, dt, dd, ol, ul, li, h1, h2, h3, h4, h5, h6, p, blockquote, pre, button, fieldset, form, input, legend, textarea, th, td {
    margin: 0;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Comment/comment.vue